/* eslint-disable */
export class LayerData {
    uid: string;
    documents_uid: string;
    users_uid: string;
    layer_data: string;
    doc_orientation: number;
}
